import { BadgeCheck, Lock, ShieldCheck, Zap } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";

const ITEMS = [
  { id: "payments", icon: ShieldCheck },
  { id: "verified", icon: BadgeCheck },
  { id: "privacy", icon: Lock },
  { id: "performance", icon: Zap },
];

export default function Trust() {
  const { t } = useLang();
  return (
    <section id="trust" className="bg-[#f3f4f6] py-28 text-[#0a1128] lg:py-40" data-testid="trust-section">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <Reveal>
          <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.35em] text-[#9a7b1e]">{t("trust.eyebrow")}</p>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <h2 className="max-w-xl font-serif text-4xl font-light leading-tight sm:text-5xl lg:text-6xl">
              {t("trust.title")}
            </h2>
            <p className="max-w-sm text-sm font-light leading-relaxed text-[#0a1128]/60 md:text-base">
              {t("trust.sub")}
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {ITEMS.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.08}>
              <article
                data-testid={`trust-card-${item.id}`}
                className="group h-full border border-[#0a1128]/10 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#d4af37]/60 hover:shadow-[0_24px_60px_-24px_rgba(10,17,40,0.25)]"
              >
                <span className="flex h-12 w-12 items-center justify-center border border-[#d4af37]/50 text-[#9a7b1e] transition-colors duration-500 group-hover:bg-[#d4af37] group-hover:text-[#0a1128]">
                  <item.icon size={20} strokeWidth={1.5} />
                </span>
                <h3 className="mt-8 font-serif text-2xl font-light">{t(`trust.${item.id}.t`)}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-[#0a1128]/60">{t(`trust.${item.id}.d`)}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
